import { useAuth0 } from "@auth0/auth0-react"
import React, { useCallback, useEffect, useState } from "react"
import { Form, Message } from "semantic-ui-react"
import BifrostButton from "../../../../../../../Components/BifrostElementComponent/BifrostButton/BifrostButton"
import Loader from "../../../../../../../Components/BifrostPageComponent/Loader/Loader"

const initialValidatedState = {
	device_id: true
}

const AddDeviceToGroupPage = ({ group, onFinish }) => {
	const [values, setValues] = useState({ device_id: null })
	const [validated, setValidated] = useState(initialValidatedState)

	const [loading, setLoading] = useState(false)
	const [optionsDevice, setOptionsDevice] = useState([])

	const [showErrorMessage, setShowErrorMessage] = useState(false)
	const { getAccessTokenSilently } = useAuth0()

	const updateField = (e, name, value) => {
		if (!name) {
			name = e.target.name
			value = e.target.value
		}
		setValues({
			...values,
			[name]: value
		})
	}

	const getAvailableDevices = useCallback(async () => {
		setLoading(true)
		const request = new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/org/" + group.org_id + "/device", {
			method: "GET",
			headers: new Headers({
				"authorization": "Bearer " + (await getAccessTokenSilently())
			})
		})

		fetch(request)
			.then((response) => {
				if (response.status !== 200) {
					return []
				}

				console.log("Got list")
				return response.json()
			})
			.then((data) => {
				const unAddedDevices = data.filter((d) => group.devices.every((d2) => d2.id !== d.id))
				setOptionsDevice(unAddedDevices.map((device) => ({ key: device.id, value: device.id, text: device.shortName })))
			})
			.catch((error) => {
				setShowErrorMessage(true)
				console.error(error)
			})
			.finally(() => {
				setLoading(false)
			})
	}, [getAccessTokenSilently, group])

	useEffect(() => {
		!optionsDevice.length && getAvailableDevices()
	}, [getAvailableDevices])

	const postDevice2Group = useCallback(
		async (data) => {
			setLoading(true)

			data.group_id = group.id

			const url = new URL(process.env.REACT_APP_SESSION_ADDR + "/api/v2/addD2G")
			const request = new Request(url, {
				method: "POST",
				headers: new Headers({
					"authorization": "Bearer " + (await getAccessTokenSilently()),
					"Content-Type": "application/json"
				}),
				body: JSON.stringify(data)
			})

			fetch(request)
				.then((response) => {
					if (response.status !== 200) {
						throw new ErrorEvent("Unexected response")
					}
					console.log("Posted Device to Group")
				})
				.then(() => onFinish())
				.catch((error) => {
					console.error(error)
					setShowErrorMessage(true)
				})
				.finally(() => {
					setLoading(false)
				})
		},
		[getAccessTokenSilently, group, onFinish]
	)

	const validateInput = () => {
		let valid = true
		let validatedCopy = { ...validated }
		for (const [key] of Object.entries(validatedCopy)) {
			if (!values[key] && values[key] !== 0) {
				validatedCopy[key] = false
				valid = false
			} else {
				validatedCopy[key] = true
			}
		}

		setValidated({ ...validatedCopy })

		return valid
	}

	const onSubmit = () => {
		validateInput() && postDevice2Group(values)
	}

	return (
		<>
			{showErrorMessage && (
				<Message negative>
					<p>Something unexpected happened</p>
				</Message>
			)}
			<Form>
				{loading ? (
					<Loader backgroundColor="white" inverted height="1px" minHeight="100px" />
				) : (
					<>
						<Form.Dropdown
							fluid
							search
							selection
							onChange={(e, { name, value }) => updateField(e, name, value)}
							name="device_id"
							placeholder="Select Device"
							options={optionsDevice}
							error={!validated.device_id}
						/>

						<BifrostButton style={{ display: "inline-block" }} onClick={() => onSubmit()}>
							Submit
						</BifrostButton>
						<BifrostButton onClick={() => onFinish()} style={{ display: "inline-block" }} color="gray">
							Cancel
						</BifrostButton>
					</>
				)}
			</Form>
		</>
	)
}

export default AddDeviceToGroupPage
